module.exports = __webpack_public_path__ + "img/03-7.39c581a0.png";